import currencies from '@/data/currencies'

export default {
  install: function(Vue, options) {
    Vue.filter('currency', function(value, iso) {
      let neg = false

      let format = currencies[iso].format

      // If no formatting string supplied
      // or amount is not a number, return as is
      if (!format || isNaN(value)) return value

      // Extract placeholders from format string
      let formFig = format.match(/\#(.*)\#/g).pop()

      // Add decimals if value has none
      value = /[,.](?=.+)/.test(value.toString()) ? value : value.toFixed(2)

      // Is number negative?
      if (value < 0) {
        neg = true
        value = value * -1
      }

      // Remove any decimals
      value = value.toString().replace(/[ ,.]/, '')

      // Split and flip the numbers and format
      let formArr = formFig.split('').reverse()
      let amtArr = value.split('').reverse()

      // Add leading zeros to small amounts, if there's a separator in last 3 digits
      if (amtArr.length < 3 && format.slice(-3).match(/[ ,.]/)) {
        while (3 - amtArr.length) {
          amtArr.push('0')
        }
      }

      // Loop through the formatting, and look for separators
      // Only get separators that fit within the length of the amount
      for (let i = 0; i < amtArr.length; ++i) {
        // If we find a matching separator, splice it into the amount in the same place
        if (/[ ,.]/.test(formArr[i])) {
          amtArr.splice(i, 0, formArr[i])
        }
      }

      // Flip the amount back in the right direction, and rejoin
      let amount = amtArr.reverse().join('')

      // Handle Negatives (minus or parentheses)
      if (!neg) format = format.replace(/[\-\(\)]/gi, '')

      // Merge the amount back with the currency symbols
      var money = format.replace(/\#(.*)\#/g, amount)

      return money
    })
  }
}
